import { Bike } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { BreazeWordmarkNav } from "@/shared/components/BreazeBranding";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  fullScreen?: boolean;
  className?: string;
}

const sizeClasses = {
  sm: "w-full max-w-[220px]",
  md: "w-full max-w-[320px]",
  lg: "w-full max-w-[520px]",
};

function GlobalLoadingSpinner({ className }: { className?: string }) {
  return (
    <div className={cn("breaze-loader", className)} role="status" aria-live="polite">
      <div className="breaze-loader-logo">
        <BreazeWordmarkNav className="h-16 max-w-[min(100%,280px)] w-auto" />
      </div>
      <div className="breaze-loader-track w-80 max-w-[min(100%,22rem)]">
        <div className="breaze-loader-track-line" />
        <div className="breaze-loader-bike">
          <Bike className="size-[1.9rem] text-primary" strokeWidth={2} aria-hidden />
        </div>
      </div>
      <p className="text-sm font-medium tracking-wide text-primary">Dispatching...</p>
    </div>
  );
}

export function LoadingSpinner({ fullScreen = false, className }: LoadingSpinnerProps) {
  if (fullScreen) {
    return (
      <div className={cn("flex min-h-[60vh] items-center justify-center px-4", className)}>
        <GlobalLoadingSpinner />
      </div>
    );
  }

  const resolvedSize = "sm";
  const loader = (
    <div className={cn("space-y-3", sizeClasses[resolvedSize], className)}>
      <Skeleton className="h-5 w-1/2 rounded-md" />
      <div className="space-y-2">
        <Skeleton className="h-3 w-full rounded-md" />
        <Skeleton className="h-3 w-5/6 rounded-md" />
        <Skeleton className="h-3 w-3/4 rounded-md" />
      </div>
      <Skeleton className="h-10 w-4/5 rounded-xl" />
    </div>
  );

  return <div className="flex items-center justify-center p-4">{loader}</div>;
}

export { GlobalLoadingSpinner };
